import React, { useState } from 'react';
import { ClipboardList, Trash2, Pencil, X, Save } from 'lucide-react';

const TaskList = ({ tasks, onDeleteTask, onEditTask, isLocked }) => {
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');

  const startEdit = (task) => {
    setEditingId(task.id);
    setEditText(task.text);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditText('');
  };

  const saveEdit = (taskId) => {
    if (editText.trim()) {
      onEditTask(taskId, editText.trim());
      setEditingId(null);
      setEditText('');
    }
  };

  const handleKeyDown = (e) => {
    // Only Escape cancels edit - Enter adds new line (default textarea behavior)
    if (e.key === 'Escape') {
      cancelEdit();
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-2 mb-2">
        <ClipboardList className="w-4 h-4 text-gray-400" />
        <span className="text-xs tracking-[0.2em] text-gray-400 font-mono uppercase">TASKS ({tasks.length})</span>
      </div>
      
      <div className="bg-[#0d1520] border border-gray-700 rounded min-h-[80px]">
        {tasks.length === 0 ? (
          <div className="flex items-center justify-center h-20">
            <span className="text-gray-500 font-mono">No tasks added yet</span>
          </div>
        ) : (
          <div className="divide-y divide-gray-700">
            {tasks.map((task) => (
              <div
                key={task.id}
                className={`p-4 transition-colors ${!isLocked ? 'active:bg-[#111a28]' : ''}`}
              >
                {editingId === task.id ? (
                  <div className="flex flex-col gap-3">
                    <textarea
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                      onKeyDown={handleKeyDown}
                      className="w-full min-h-[120px] bg-[#1a2535] border border-gray-600 rounded px-3 py-2 text-white font-mono text-sm focus:outline-none focus:border-[#d4a636] resize-y"
                      autoFocus
                      placeholder="Edit task..."
                    />
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={cancelEdit}
                        data-testid="edit-cancel-button"
                        className="px-3 py-2 text-gray-400 hover:text-gray-200 font-mono text-sm transition-colors flex items-center gap-1"
                      >
                        <X className="w-4 h-4" />
                        <span>Cancel</span>
                      </button>
                      <button
                        onClick={() => saveEdit(task.id)}
                        data-testid="edit-save-button"
                        className="px-3 py-2 bg-[#d4a636] hover:bg-[#c49526] text-[#0a1018] font-mono text-sm font-semibold rounded transition-colors flex items-center gap-1"
                      >
                        <Save className="w-4 h-4" />
                        <span>Save</span>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-start gap-3">
                    <span className="flex-1 font-mono text-sm leading-relaxed text-gray-200 whitespace-pre-wrap">
                      {task.text}
                    </span>
                    
                    {!isLocked && (
                      <div className="flex-shrink-0 flex items-center gap-3">
                        <button
                          onClick={() => startEdit(task)}
                          data-testid={`edit-task-${task.id}`}
                          className="text-gray-400 hover:text-[#d4a636] active:text-[#d4a636] transition-colors p-1"
                        >
                          <Pencil className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() => onDeleteTask(task.id)}
                          data-testid={`delete-task-${task.id}`}
                          className="text-gray-400 hover:text-red-400 active:text-red-400 transition-colors p-1"
                        >
                          <Trash2 className="w-5 h-5" />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskList;
